module.exports = __webpack_public_path__ + "static/media/phone.4853d4ab.svg";